import React from 'react';
import Dialog from '../dialog/Dialog';
import { ButtonColor } from '../button/Button';

export interface IErrorModalProps {
  title: string;
  // tslint:disable-next-line: ban-types
  description: string | Function;
  button: string;
  buttonColor?: ButtonColor;
  isOpen: boolean;
  errorCode?: string;
  payload?: any;
  submit: () => void;
}

// tslint:disable-next-line:variable-name
const ErrorModal: React.FC<IErrorModalProps> = (props) => {
  if (!props.isOpen) {
    return null;
  }
  const action1 = props.button ? { text: props.button, value: 1, color: props.buttonColor } : undefined;
  const displayTxt = typeof props.description === 'function' ? props.description(props.payload) : props.description;
  return (
    <Dialog onAction={props.submit} action1={action1} title={props.title}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: displayTxt }} />
    </Dialog>
  );
};

export default ErrorModal;
